import { mapMutations } from "vuex"
import { api } from "@/plugins/api"

export default {
  data() {
    return {
      loading: true,
    }
  },
  methods: {
    ...mapMutations(["SET_CHAMPS", "SET_RESSOURCES", "SET_CATALOGUES"]),
    async loadParams(id) {
      this.loading = true
      await api.get(`params-formulaires/${id}`)
        .then((res) => {
          const paramsFormulaire = res.data

          if (paramsFormulaire.champs && paramsFormulaire.champs.length > 0) {
            this.SET_CHAMPS(paramsFormulaire.champs)
          }
          if (paramsFormulaire.ressources && paramsFormulaire.ressources.length > 0) {
            this.SET_RESSOURCES(paramsFormulaire.ressources)
          }
          if (paramsFormulaire.catalogues && paramsFormulaire.catalogues.length > 0) {
            this.SET_CATALOGUES(paramsFormulaire.catalogues)
          }
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}

